/* check: https://rangle.gitbook.io/redux-beacon/index/google-analytics */

const eventsMapperGA = {}

export default eventsMapperGA
